import { pathes } from '@/routing/pathes'
import {
  deleteAccessToken,
  setRefreshToken,
} from '@/shahrzad-assets/shared-constants/localstorage'
import { Buffer } from 'buffer'
import { postGetRefreshTokenToApp } from './postGetRefreshToken'

const fromBase64 = (decodedValue) => {
  return Buffer.from(decodedValue, 'base64').toString('utf8')
}

interface IProps {
  justCheckIsRefreshToken: boolean
  tokenFromApp?: string
  pathname?: string
}

export const getTokenFromApp = async ({
  justCheckIsRefreshToken = false,
  tokenFromApp,
  pathname,
}: IProps) => {
  try {
    if (tokenFromApp) {
      //در اپلیکیشن از ورژن 4.0.6 به بعد از این روش برای فرستادن توکن استفاده شده
      if (justCheckIsRefreshToken) {
        const encodedToken = await fromBase64(tokenFromApp)
        setRefreshToken(encodedToken)
        deleteAccessToken()
        // const url = import.meta.env.VITE_MAIN_WEB_URL + pathes.BASE_PATH + pathname
        window.location.replace(window.location.origin + window.location.pathname) 
      }
    } 
  } catch (err) {
    alert(JSON.stringify(err))
  }
}

// import {
//   deleteAccessToken,
//   setRefreshToken,
// } from '@/shahrzad-assets/shared-constants/localstorage'
// import { postGetRefreshTokenToApp } from './postGetRefreshToken'

// export const getTokenFromApp = (justCheckIsRefreshToken = false) => {
//   try {
//     window.addEventListener('message', function (data) {
//       const res = JSON.stringify(data.data)
//       if (res.includes('fromApp')) {
//         const data = JSON.parse(res)
//         if (justCheckIsRefreshToken) {
//           if (data?.isRefreshTokenUpdate) {
//             data?.refreshTokenfromApp &&
//               setRefreshToken(data?.refreshTokenfromApp)
//             postGetRefreshTokenToApp()
//             deleteAccessToken()
//             window.location.reload()
//           } else {
//             postGetRefreshTokenToApp()
//           }
//         } else {
//           data?.refreshTokenfromApp &&
//             setRefreshToken(data?.refreshTokenfromApp)
//           postGetRefreshTokenToApp()
//           deleteAccessToken()
//           window.location.reload()
//         }
//       }
//     })
//   } catch (err) {
//     alert(JSON.stringify(err))
//   }
// }
